<template>
    <section class="related">
        <h3 class="related__title">related {{ title }}</h3>
        <div class="related__items">
            <router-link v-for="(item, index) in items" :key="index" :to="baseUrl + item.ID" class="related__item">
                <template v-if="isProducts">
                    <AppProductCard :content="item" />
                </template>
                <template v-else>
                    <AppNewsCard :content="item" :hasDate="false"/>
                </template>
            </router-link>
        </div>
        <AppButton class="related__shop" :text="this.label" :link="{path: buttonUrl, query: backQuery}" />
    </section>
</template>

<script>
import AppProductCard from '@/components/AppProductCard'
import AppNewsCard from '@/components/AppNewsCard'
import AppButton from '@/components/AppButton'

export default {
  name: 'app-related',

  components: {
      AppProductCard,
      AppNewsCard,
      AppButton
    },

  props: {
      isProducts: {
          type: Boolean,
          default: true
      },
      items: {
          type: Array,
          default: null
      },
      label: {
          type: String,
          default: ''
      },
      query: {
          type: Object,
          default: null
      }
  },

  computed: {
    title()
    {
        return this.isProducts ? 'products' : 'news'
    },
    buttonUrl()
    {
        return this.isProducts ? '/shop' : '/articles'
    },

    baseUrl() 
    {
        return this.isProducts ? '/product/' : '/articles/'
    },

    backQuery()
    {
      const obj = this.buttonUrl.indexOf('shop') > -1 ? this.query ? {
        ...this.$route.query,
        ...this.query
      } : {} : {}

      return  obj
    },
  },

  data()
  {
    return {

    }
  },

  created()
  {

  },

  mounted()
  {

  },

  destroyed()
  {

  }
}
</script>

<style lang="stylus">
    .related__title
        line-height 1
        text-transform uppercase
        text-align center
        interpolate('font-size', 1600px, 2560px, 60px, 84px);

        @media(max-width 1600px)
            interpolate('font-size', 768px, 1600px, 30px, 60px);

        @media(max-width 768px)
            margin 0px 40px
            font-size 32px

    .related__items
        width auto
        // max-width 1000px
        interpolate('margin-top', 768px, 2560px, 50px, 150px);
        interpolate('margin-bottom', 768px, 2560px, 50px, 150px);
        margin-left auto
        margin-right auto
        display flex
        justify-content center

        @media(max-width 768px)
            flex-direction column
            align-items center
            margin 40px auto

    .related__item
        width calc(100% / 22 * 6)
        display block
        margin-right calc(100% / 22 * 2)

        &:last-child
            margin-right 0

        @media(max-width 768px)
            width 75%
            margin-right 0
            margin-bottom 40px

    .related__item__img
        width 100%
        display block

    .related__item--news__image
        position relative
        width 100%
        margin-bottom 40px

        &:before
            content ''
            display block
            padding-top 100%

    .related__item--news__image__elem
        position absolute
        top 0
        left 0
        width 100%
        height 100%
        object-fit cover

    .related__item--news__title
        max-width 70%
        text-transform uppercase
        font-size 18px
        line-height 1.2

    .related__shop
        margin 0 auto
        display block
</style>